import React from 'react';
import configs from '../../configs/configs.json';
import { formattedDate } from "../../helpers/DateHelpers";

import { Image } from 'antd';
import './style.scss';

interface propsInterface {
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  image?: string;
  createdAt: string;
  updatedAt: string;
  publishedAt?: string;
  className?: string;
  dateName1?: string;
  dateName2?: string;
  dateName3?: string;
  actions?: React.ReactNode[];
}

const SummaryShow = (
  {
    title,
    subtitle,
    image,
    actions,
    createdAt,
    updatedAt,
    publishedAt,
    className,
    dateName1 = 'Created at',
    dateName2 = 'Updated at',
    dateName3 = 'Published at',
  }: propsInterface
) => {
  const formattedCreatedAt = formattedDate(createdAt);
  const formattedUpdatedAt = formattedDate(updatedAt);

  function PublishedAt() {
    if(!publishedAt) {
      return null;
    }

    const formattedPublishedAt = formattedDate(publishedAt);
    return (
      <div className='o-media'>
        <div className='o-body'>
          <label>{dateName3}</label>
          <h6>{formattedPublishedAt.date} <small>{formattedPublishedAt.time}</small></h6>
        </div>
      </div>
    )
  }

  return (
    <div className={`v-summary-record ${className || ''}`}>
      <div className='v-summary-record--left'>
        <div className='o-image'>
          <Image
            width={75}
            height={75}
            src={image || 'not_found'}
            fallback={configs.IMAGES.FALLBACK}
          />
        </div>

        <div>
          <h6>{title}</h6>
          <div className='v-summary-record--subtitle'>{subtitle}</div>
        </div>
      </div>

      <div className='v-summary-record--right'>
        <div className='o-media'>
          <div className='o-body'>
            <label>{dateName1}</label>
            <h6>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></h6>
          </div>
        </div>

        <div className='o-media'>
          <div className='o-body'>
            <label>{dateName2}</label>
            <h6>{formattedUpdatedAt.date} <small>{formattedUpdatedAt.time}</small></h6>
          </div>
        </div>

        <PublishedAt />

        {
          actions &&
            <div className='v-summary-record--actions o-media'>
              <div className='o-body'>
                { actions }
              </div>
            </div>
        }
      </div>
    </div>
  );
}

export default SummaryShow;
